const Alert = {
  parts: ['container'],
  baseStyle: {
    container: {
      px: '14px',
      py: '14px',
      button: {
        right: 2,
        top: 3,
      },
    },
    description: {
      paddingRight: '14px',
    },
  },
  variants: {
    success: {
      container: {
        bgColor: 'success',
        color: 'white',
      },
    },
    warning: {
      container: {
        bgColor: 'warning',
        color: 'white',
      },
    },
    error: {
      container: {
        bgColor: 'danger',
        color: 'white',
      },
    },
  },
};

export default Alert;
